<template>
  <div>
    <el-drawer
      :title="`Empresa:   ${data.Empresa.nombre}`"
      :visible.sync="drawer"
      size="90%"
      v-bind="$attrs"
      @closed="onDrawerClose"
    >
      <el-row class="filaPrinc">
        <el-col>
          <el-row :gutter="10" class="filaPrinc">
            <el-col :span="12">
              <el-row :gutter="5">
                <el-col :span="6">
                  <span>RNC de la Empresa: </span>
                </el-col>
                <el-col :span="12">
                  <span class="black-text font-weight-800">{{
                    data.Empresa.rnc
                  }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="5">
                <el-col :span="5">
                  <span> Contacto: </span>
                </el-col>
                <el-col :span="12">
                  <span class="black-text font-weight-800">{{
                    data.Empresa.Direccion3
                  }}</span>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row :gutter="5">
                <el-col :span="4">
                  <span>Direccion: </span>
                </el-col>
                <el-col :span="15">
                  <span class="black-text font-weight-800">{{
                    data.Empresa.Direccion1
                  }}</span>
                </el-col>
              </el-row>
              <el-row :gutter="5">
                <el-col :span="6">
                  <span>Coreo electronico:</span>
                </el-col>
                <el-col :span="12">
                  <span class="black-text font-weight-800">{{
                    data.Empresa.Email
                  }}</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <div class="card-base card-shadow--medium">
                <rabbey-table-3
                  ref="table"
                  class="table"
                  :max-height="700"
                  v-loading="loading"
                  :columns="columnas"
                  :data.sync="ResultadoTerminalesDetalle"
                  :page-sizes="[10, 30, 50, 100, 500, 1000]"
                />
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <ReportServicesDetails
        ref="detailServices"
        :append-to-body="true"
        openDrawer="openReportServicesDetails"
      />
    </el-drawer>
  </div>
</template>

<script>
import ColorTagsinLineFormatter from "@/components/functionals/ColorTagsinLineFormatter";
import ReportTerminalsServicesHyperLink from "@/components/functionals/ReportTerminalsServicesHyoerLink";
import ReportServicesDetails from "@/components/reports/ReportServicesDetails.vue";
import { formatDate } from "@/utils.js";

export default {
  data() {
    return {
      loading: false,
      drawer: false,
      data: {},
      ResultadoTerminalesDetalle: [],

      columnas: [
        /*
        {
          prop: "Empresa.rnc",
          label: "RNC de la Empresa",
          sortable: true
        },
        {
          prop: "Empresa.nombre",
          label: "RNC de la Empresa",
          sortable: true
        },
        {
          prop: "Empresa.direccion1",
          label: "Direccion de la Empresa",
          sortable: true
        },
        {
          prop: "Empresa.direccion2",
          label: "Provincia",
          sortable: true
        },
        */
        {
          prop: "terminalid",
          label: "ID#",
          sortable: true,
          width: 90,
          align: "center",
          fixed: true
        },
        {
          prop: "rnc",
          label: "RNC Terminal",
          sortable: true,
          width: 170,
          align: "center",
          fixed: true
        },
        {
          prop: "terminal",
          label: "Terminal",
          sortable: true,
          width: 100,
          align: "center"
        },
        {
          prop: "Serie_Terminal",
          label: "Serie Terminal",
          minWidth: 170
        },
        {
          prop: "Serie_Walk",
          label: "Serie Walk",
          minWidth: 130
        },
        {
          prop: "Modelo",
          label: "Modelo",
          sortable: true,
          width: 130
        },
        {
          prop: "LastDate",
          label: "Ultima Transaccion",
          sortable: true,
          width: 190,
          formatter: (row) => formatDate(row.LastDate)
        },
        {
          prop: "TotalServices",
          label: "Total Servicios",
          sortable: true,
          width: 160,
          align: "center",
          attrs: {
            OpenServiciosDetail: this.OpenServiciosDetail
          },
          formatter: ReportTerminalsServicesHyperLink
        },
        {
          prop: "nombre",
          label: "Nombre",
          sortable: true,
          width: 110,
          align: "center"
        },
        {
          prop: "Status",
          label: "Estado",
          sortable: true,
          width: 120,
          align: "center",
          formatter: ColorTagsinLineFormatter
        },
        {
          prop: "direccion3",
          label: "Contacto",
          sortable: true,
          width: 190
        },
        {
          prop: "direccion1",
          label: "Direccion",
          sortable: true,
          width: 220
        },
        {
          prop: "direccion2",
          label: "Zona",
          sortable: true,
          width: 220
        }
      ],

      openReportServicesDetails: false
    };
  },
  components: {
    ReportServicesDetails
  },

  methods: {
    show(data, type) {
      this.data = data;

      switch (type) {
        case "CantTotalTerminales":
          this.ResultadoTerminalesDetalle = data.TerminalesTotales;

          break;
        case "CantTeminalesActivas":
          this.ResultadoTerminalesDetalle = data.TeminalesActivas;

          break;
        case "CantTeminalesInactivas":
          this.ResultadoTerminalesDetalle = data.TeminalesInactivas;

          break;
      }

      this.ResultadoTerminalesDetalle.forEach((Terminal) => {
        switch (Terminal.Status) {
          case "ACT":
            Terminal.Status = "Activa";
            break;
          case "INA":
            Terminal.Status = "Inactiva";
            break;
        }
      });

      // data.Empresas_Terminales.forEach(terminal => {

      //   switch (terminal.Status) {
      //     case "ACT":
      //       data.Empresas_Terminales= data.Empresas_Terminales.filter(terminal => terminal.Status === "ACT");
      //       break;
      //     case "INA":
      //       data.Empresas_Terminales= data.Empresas_Terminales.filter(terminal => terminal.Status === "INA");
      //       break;
      //   }
      // }
      // );
      // this.ResultadoTerminalesDetalle.push(data);

      this.drawer = true;
    },
    OpenServiciosDetail(row, type) {
      this.openReportServicesDetails = true;
      this.$refs.detailServices.show(row, type);
    },

    onDrawerClose() {
      this.ResultadoTerminalesDetalle = [];
    }
  }
};
</script>

<style scoped>
.filaPrinc {
  margin-top: 15px;
  margin-left: 15px;
  padding-left: 30px;
  padding: true;
}
</style>
